import { GQLLandingPageFragment } from "@src/graphql.apollo.generated";
import useDisplayName from "@src/shared/context/displayname/useDisplayName";
import getFormattedNumber from "@src/shared/utils/getFormattedNumber";

export default function useSEOContent({ scheme, disabled, filters }: GQLLandingPageFragment, totalCount: number) {
    const { getDisplayName } = useDisplayName();

    const financeType = getDisplayName("financeType", filters.financeType);
    const brand = getDisplayName("brands", filters.brands?.[0]);
    let modelGroup = getDisplayName("modelGroups", filters.modelGroups?.[0]);
    const bodyType = getDisplayName("bodyTypes", filters.bodyTypes?.[0]);
    const province = getDisplayName("provinces", filters.provinces?.[0]);

    function replaceWildCards(text: string | null) {
        if (text === null) {
            return "";
        }

        if (brand && modelGroup?.includes(brand)) {
            const commonPart = modelGroup.match(new RegExp(brand, "i"))?.[0]; // Search for commond part
            if (commonPart) {
                modelGroup = modelGroup.replace(commonPart, "").trim(); // Only remove common part
            }
        }

        return (
            text
                .replace(new RegExp("%finance_type%", "g"), financeType || "")
                .replace(new RegExp("%brand%", "g"), brand || "")
                .replace(new RegExp("%model%", "g"), modelGroup || "")
                .replace(new RegExp("%chassis%", "g"), bodyType || "")
                .replace(new RegExp("%state%", "g"), province || "")
                .replace(new RegExp("%count%", "g"), getFormattedNumber(totalCount))
                // TODO use real data once available
                .replace(new RegExp("%location%", "g"), province || "")
                .replace(new RegExp("%vehicle_state%", "g"), "Gebrauchtwagen")
        );
    }

    const headline = replaceWildCards(scheme.headline);
    const title = replaceWildCards(scheme.title);
    const description = replaceWildCards(scheme.description);
    const content = replaceWildCards(scheme.content);

    return { headline, title, description, content, noIndex: disabled };
}
